/**
 * Pages
 */

export * from './pages/FastTrackIssuesCreate/FastTrackIssuesCreate';
export * from './pages/FastTrackIssuesDetail/FastTrackIssuesDetail';
